import { startOfWeek, format } from "date-fns";

/**
 * Renvoie la date du lundi de la semaine contenant `date`,
 * formatée "YYYY-MM-DD" en timezone LOCALE (jamais UTC).
 *
 * Remplace toute utilisation de d.toISOString().split("T")[0]
 * qui décale le résultat d'un jour en UTC+ (ex. France UTC+2).
 */
export function getWeekStartString(date: Date): string {
  return format(startOfWeek(date, { weekStartsOn: 1 }), "yyyy-MM-dd");
}
